export { default } from "./BannerHeaderText";
